import type { LinkProps } from '@mui/material/Link';

import { mergeClasses } from 'minimal-shared/utils';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';

import { RouterLink } from 'src/routes/components';

import { logoClasses } from './classes';

// ----------------------------------------------------------------------
// Wordmark — the "[cmpr]" text logo: cobalt brackets, text.primary "cmpr".
// Per design/components.md: DM Sans 900, letter-spacing ≈ -0.04em, brackets
// always cobalt, never recolored, never set in the serif face.
// ----------------------------------------------------------------------

export type WordmarkProps = LinkProps & {
  disabled?: boolean;
};

export function Wordmark({ sx, disabled, className, href = '/', ...other }: WordmarkProps) {
  return (
    <WordmarkRoot
      component={RouterLink}
      href={href}
      aria-label="cmpr"
      underline="none"
      className={mergeClasses([logoClasses.root, className])}
      sx={[{ ...(disabled && { pointerEvents: 'none' }) }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...other}
    >
      <Box
        component="span"
        sx={{
          fontFamily: '"DM Sans Variable", "DM Sans", sans-serif',
          fontWeight: 900,
          fontSize: '1.25rem',
          letterSpacing: '-0.04em',
          lineHeight: 1,
          color: 'text.primary',
        }}
      >
        <Box component="span" sx={{ color: 'primary.main' }}>
          [
        </Box>
        cmpr
        <Box component="span" sx={{ color: 'primary.main' }}>
          ]
        </Box>
      </Box>
    </WordmarkRoot>
  );
}

// ----------------------------------------------------------------------

const WordmarkRoot = styled(Link)(() => ({
  flexShrink: 0,
  display: 'inline-flex',
  alignItems: 'center',
  verticalAlign: 'middle',
}));
